
const mca = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/mca.webp"
const coral_reef="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/coral_reef_alumni.webp"
const alumni_1982="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/alumni_1982.webp"
const silver_98="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/silver_98.webp"
const pre_gold_79="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/pre_gold_79.webp"
const diam_68="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/alumni_pics/diam_68.webp"
const contrib_pic="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/about/clgphoto.webp"
const alumni1="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/about/alumni1.webp"
const alumni2="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/about/alumni2.webp"
const alumni3="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/about/alumni3.webp"
const alumni4="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/ACCET+1978+Meeting.webp"
const alumni5="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/EXCERPT+Of+ACCETOSA+Get-together.webp"
const alumni6="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/42nd+Year+Get-together1.webp"
const alumni7="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/silver+jublie+2024.webp"
const alumni8="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/40TH+YEAR+REUNION.webp"
const alumni9="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/2024+Reunion+Meeting+at+Madikeri.webp"
const alumni10="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/Reunion+of+Our+Prestigious+Alumnis.webp"
const alumni11="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/new+year.webp"
const alumni12="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/Album_+ACCET+1963-68+Batch.webp"
const alumni13="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/Impressions+of+the+Golden+Jubilee+Celebration.webp"
const alumni14="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2024/Alumni+Mark+Ruby+Jubilee.webp"
const alumni15="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/alumnii15.webp"
const alumni16="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/alumnii16.webp"
const alumni17="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/alumnii17.webp"
const alumni18="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/alumnii18.webp"
const almini_19="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/diamond_jublie_cele.webp"
const alumini_20="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/goldern_jublie_cele.webp"
const alumini_21="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/friendship_tour.webp"
const alumini_22="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/Accet'78+Batch.webp"
const alumini_23="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/Accet'86+Batch.webp"
const alumni_24="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/Accet'60+batch.webp"
const alumni_25="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/Accet'75.webp"
const alumni_26="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/down_mwmory1_lane.webp"
const alumni_27="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/Accet'79.webp"
const alumni_28="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/Accet'79_2.webp"
const alumni_29="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/Accet'69.webp"
const alumni_30="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/alumini/reunions/2025/Accet'94.webp"
export const contributions=[
    {
        'id':'1',
        'heading':"One Week Training on Robotics",
        'sub-head':'Explanation....',
        'pic':contrib_pic,
        'content_1':'Our Commitment as a Centre of Engineering Education is to impart Technical Knowledge par excellence, motivate the learners in Research, evolve result-oriented, innovative techniques in Engineering, provide necessary career guidance, and train our learners'+
                    'in leadership qualities so as to achieve better productivity and prosperity for our country.',
        'content_2':"ACGCET, a leader in higher education in engineering and technology, is committed to excellence through the delivery of outstanding undergraduate and graduate education that remains current and responsive to the diverse needs of those it serves. The institution’s"+
        "faculty and staff promote the intellectual, professional, social, and personal development of its students through innovations in learning, scholarship, and creative endeavours. Students, faculty, and staff partner to create strong"+
        "engagement with the local, national, and global communities. The institution dedicates itself to academic vitality, integrity, and diversity."
    },
    {
        'id':'2',
        'heading':'Heading2',
        'sub-head':'Explanation....',
        'pic':contrib_pic,
        'content_1':'Our Commitment as a Centre of Engineering Education is to impart Technical Knowledge par excellence, motivate the learners in Research, evolve result-oriented, innovative techniques in Engineering, provide necessary career guidance, and train our learners'+
                    'in leadership qualities so as to achieve better productivity and prosperity for our country.',
        'content_2':"ACGCET, a leader in higher education in engineering and technology, is committed to excellence through the delivery of outstanding undergraduate and graduate education that remains current and responsive to the diverse needs of those it serves. The institution’s"+
        "faculty and staff promote the intellectual, professional, social, and personal development of its students through innovations in learning, scholarship, and creative endeavours. Students, faculty, and staff partner to create strong"+
        "engagement with the local, national, and global communities. The institution dedicates itself to academic vitality, integrity, and diversity."
    },
    {
        'id':'2',
        'heading':'Heading2',
        'sub-head':'Explanation....',
        'pic':contrib_pic,
        'content_1':'Our Commitment as a Centre of Engineering Education is to impart Technical Knowledge par excellence, motivate the learners in Research, evolve result-oriented, innovative techniques in Engineering, provide necessary career guidance, and train our learners'+
                    'in leadership qualities so as to achieve better productivity and prosperity for our country.',
        'content_2':"ACGCET, a leader in higher education in engineering and technology, is committed to excellence through the delivery of outstanding undergraduate and graduate education that remains current and responsive to the diverse needs of those it serves. The institution’s"+
        "faculty and staff promote the intellectual, professional, social, and personal development of its students through innovations in learning, scholarship, and creative endeavours. Students, faculty, and staff partner to create strong"+
        "engagement with the local, national, and global communities. The institution dedicates itself to academic vitality, integrity, and diversity."
    },
]

export const slideshow_imgs=[
    alumni1,
    alumni2,
    alumni3
]

export const alumni_reunions=[  //2023
    {
        id:'1',
        coverpic:diam_68,
        batch:"1963-68",
        name:"Diamond Jubilee Celebration",
        desc:"The 1963 Freshmen held their Diamond Jubilee celebration on february 11, reliving college memories joyfully.",
        date:"11th FEB 2023"

    },
    {
        id:'2',
        coverpic:pre_gold_79,
        batch:"1974-79",
        name:"Pre-Golden Jubilee Meet",
        desc:"1974-79 ACCET alumni held a Pre-Golden Jubilee meet at Chennai, planning future events and skill development initiatives.",
        date:"29th & 30th MAR 2023"
    },
     {
        id:'3',
        coverpic:silver_98,
        batch:"1994-98",
        name:"Silver Jubilee Celebrations",
        desc:"Our heartfelt wishes to the Alumni of the 1994-98 Batch celebrating their Silver Jubilee on the ACCET Campus.!!",
        date:"16th JUL 2023"
    },
    {
        id:'4',
        coverpic:alumni_1982,
        batch:"1978-82",
        name:"41st-Year Reunion Of Class 1982",
        desc:"The 1982 batch celebrated their 41st-year reunion at Kolli Hills on August 12-13, reliving college memories joyfully.",
        date:"12th & 13th AUG 2023"
    },
    {
        id:'5',
        coverpic:coral_reef,
        batch:"1984-88",
        name:"35th Coral Reef Batch Meet",
        desc:"1984-88 batch's 35th reunion in Kodaikanal on Aug 18-19 celebrated genuine connections and shared memories with 63 attendees.",
        date:"18th & 19th AUG 2023"
    },
   
    
]
export const cardData = [
    {
        imageSrc:mca,
      title: ' Reunion of 1990-93 batch of MCA',
      
      videoSrc: 'https://drive.google.com/file/d/1vnlvSMtcF4JNZizii5MfpH1h4NcSgZWX/view?usp=sharing'
    },
]
 export const alumini_reunion_2025 = [
     {
        id:'1',
        coverpic:alumni11,
        batch:"1972-77",
        name:"New Year 2025 -Reunion Celebrated",
        desc:"We, the 1972-77 Batch Alumni organized and celebrated the New Year 2025-Reunion with our family Members at Madras Cricket Club (MCC) on 19th January 2025.",
        date:"19th JAN 2025"
    },
      
    
    {
        id:'2',
        coverpic:alumni12,
        batch:"1963-68",
        name:" 1963-68 Batch Alumni - 57th Year of Graduation",
        desc:"We,the 1963-68 batch celebrated their 57th year of graduation/ 62nd year of joining alma mater at Cosmopolitan Club in Chennai. ",
        date:"8th FEB 2025"
    },
    {
        id:'3',
        coverpic:alumni16,
        batch:"1980-84",
        name:" 40th Anniversary Reunion Celebration",
        desc:"We,The 1980–84 Batch Alumni celebrated their 40th anniversary (Ruby Jubilee) reunion on the college.",
        date:"23th FEB 2025"
    },
    {
        id:'4',
        coverpic:alumni13,
        batch:"1970-75",
        name:"Golden Jubilee Celebration",
        desc:"A memorable gathering that brought together alumni from across the globe, celebrating four decades of friendship, shared experiences, and enduring bonds with the institution.",
        date:"21st FEB 2025"
    },
    {
        id:'5',
        coverpic:alumni14,
        batch:"1981-85",
        name:"Alumni Mark Ruby Jubilee",
        desc:"We, the 1981–85 Batch Alumni, organized and celebrated our 40th Year  Reunion with our family members at ACCET on 19th -24th March 2025.",
        date:"19th & 24th MAR 2025"
    },
   
    {
        id:'6',
        coverpic:alumni15,
        batch:"1972-77",
        name:"Golden Jubilee Trip-2025",
        desc:"We, a group of 28 alumni and their family members, commenced our journey from Chennai to Srinagar via New Delhi on the morning of April 18 ",
        date:"18th APR 2025"
    },
    {
    
        id:'7',
        coverpic:alumni17,
        batch:"1992-95",
        name:"MCA-A Legacy of Connection",
        desc:"We are truly delighted to stand before you today and reflect on the beautiful moments we shared during our MCA 1992–1995 Reunion.",
        date:"7th JUL 2025"
    },
    {
    
        id:'8',
        coverpic:alumni18,
        batch:"1971-74",
        name:"Diamond Jubilee Celebration",
        desc:"We are very happy to share  the memorable moments we shared during our Diamond Jubilee Celebration.",
        date:"30th & 31st JUL 2025"
    },

    {
        id:'9',
        coverpic:almini_19,
        batch:"1960-65",
        name:"Diamond Jubilee Reunion Celebration",
        desc:"We, the 1960-65 Batch Alumni celebrated their Diamond Jubilee Reunion on the college campus.",
        date:"11th NOV 2025"
    },
    {
        id:'8',
        coverpic:alumini_20,
        batch:"1975-80",
        name:"Golden Jubilee Reunion Celebration",
        desc:"We, the 1975-80 Batch Alumni celebrated their Golden Jubilee Reunion on the college campus.",
        date:"11th DEC 2025"
    },
   {
    id:'9',
    coverpic:alumini_21,
    batch:"1967-72",
    name:"17th Annual Friendship Tour",
    desc:"We, the 1967-72 Batch Alumni celebrated their 17th Annual Friendship Tour at AR Thanga Kottai (ARTK), Yelagiri.",
    date:" 1st & 3rd AUG 2025"

   },
   {
    id:'10',
    coverpic:alumini_22,
    batch:"1978-82",
    name:"Reunion Celebration ",
    desc:"We, the 1978-82 Batch Alumni celebrated their reunion Celebration at ACCET munnar.",
    date:" 1st & 3rd AUG 2025"
   },
   {
    id:'11',
    coverpic:alumini_23,
    batch:"1986-90",
    name:" Coral Jubilee Reunion",
    desc:"The 1986-90 Batch Alumni celebrated their coral jubilee reunion at Discovery Village Nandi Hills.",
    date:" 26th & 27th JUL 2025"
   },
   
   {
    id:'12',
    coverpic:alumni_26,
    batch:"1976-81",
    name:"Reunion of 1976-81 Class",
    desc:"The batch of 1976-81 Batch Alumni celebrated our Reunion at Vagamon.",
    date:"16th & 19th SEP 2025"
   },
   {
    id:'13',
    coverpic:alumni_27,
    batch:"1979-84",
    name:"Reunion of 1979-84 Class",
    desc:"We , the batch of 1979-84 Batch Alumni celebrated our Reunion at Poovar,Kerala.",
    date:"12th & 14th SEP 2025"
   },
   {
    id:'14',
    coverpic:alumni_28,
    batch:"1979-84",
    name:"1978 Batch Alumni Mini-Meet",
    desc:"We , the batch of 1978 Batch Alumni celebrated our Mini-Meet at Madurai.",
    date:"12th OCT 2025"
   },
   {
    id:'15',
    coverpic:alumni_29,
    batch:"1969-74",
    name:"1969–74 Batch Grand Meet",
    desc:"The batch of 1969-74 Batch Alumni celebrated our great reunion at Coral Beach Resort,Mahabalipuram.",
    date:"20th & 22th DEC 2025"
   },
//    {
//     id:'18',
//     coverpic:alumni_30,
//     batch:"1994-1998",
//     name:"1994-98 Batch-A Mini SJC in Guindy",
//     desc:"We, the batch of 1994-98 Batch Alumni are planning to have a Mini SJC at Guindy, Chennai.",
//     date:""
//    }

    
    
    
    
  ]
   export const alumini_reunion_2024 = [
      
    {
        id:'1',
        coverpic:alumni4,
        batch:"1973-78",
        name:"ACCET 1978 Meeting for Lunch",
        desc:"ACCET 1978 Meeting for Lunch was conducted on 29/02/24 Thursday from 11.30 am to 02.00 pm at Hotel Mathsya, Adyar, Chennai.",
        date:"29th FEB 2024"
    },
    {
        id:'2',
        coverpic:alumni10,
        batch:"1990-93",
        name:"Reunion of Our Prestigious Alumni ",
        desc:"The alumni of 1990-1993 MCA batch assembled on college campus 28 Jun 2024 for celebrating their 30 years-completion of their course.",
        date:"28th JUN 2024"
    },

    
    //{
     //   id:'4',
     //   coverpic:alumni7,
     //   batch:"1995-99",
     //   name:"Silver Jubilee Celebrations",
     //   desc:"The Silver Jubilee Celebration of the 1995-99 batch alumni marked a significant milestone, not only for the institution but also for the graduates .",
     //   date:"13th JUL 2024"
    //},
    {
        id:'4',
        coverpic:alumni6,
        batch:"1982-87",
        name:"42nd Year Get-together",
        desc:"42nd Year Get-together of the 1982 Batch Alumni at POOVAR// 10th & 11th August 2024   Location: Poovar    Date: 10 Aug 2024",
        date:"11th AUG 2024"
    },
    {
        id:'5',
        coverpic:alumni8,
        batch:"1979-84",
        name:"40th Year Reunion of batch 1979-84",
        desc:"Our revered alumni of the batch 1979-84 had a get-together for the 40th year of their course completion. About 50 members assembled on the campus .",
        date:"17th &18th AUG 2024"
    },
    {
        id:'6',
        coverpic:alumni9,
        batch:"1976-81",
        name:"2024 Reunion Meeting at Madikeri",
        desc:"As shared by Er. A. Naresh Kumar of 1976-81 batch. The yearly December reunion of the 1976-81 batch was organized at Madikeri, Coorg 4. ",
        date:"27th - 30th DEC 2024"
    },
    
    
  ];